<template>
  <v-container fluid="fluid">
    <v-card>
      <v-toolbar class="elevation-0" height="45" color="gray">
        <v-toolbar-title>
          <h1 class="subheading">SMS Wallet Balances</h1>
        </v-toolbar-title>
        <v-spacer></v-spacer>
        <v-tooltip class="ml-1 pointer" bottom="bottom">
          <template slot="activator">
            <v-btn flat="flat" @click="reloadData" icon="icon">
              <v-icon>refresh</v-icon>
            </v-btn>
          </template>
          <span>Refresh Data</span>
        </v-tooltip>
        <v-btn small color="success" @click="downloadCSV">Download CSV</v-btn>
      </v-toolbar>
      <v-card-title>
        <v-flex xs12 sm6>
          <v-text-field
            v-model="search"
            prepend-icon="search"
            label="Search"
            clearable="clearable"
            single-line="single-line"
            hide-details="hide-details"
          ></v-text-field>
        </v-flex>
        <v-flex xs12 sm3 class="ml-3">
          <v-select
            v-model="recurlyFilter"
            :items="recurlyFilterOptions"
            label="Recurly Status"
            hide-details="hide-details"
          ></v-select>
        </v-flex>
      </v-card-title>
      <v-data-table
        :headers="headers"
        item-key="storeID"
        :items="filteredItems"
        :search="search"
        :loading="loading"
        :pagination.sync="pagination"
      >
        <template slot="items" slot-scope="props">
          <tr class="pointer">
            <td class="text-xs-left">{{ props.item.storeID }}</td>
            <td class="text-xs-left">
              <a @click="openLocation(props.item)">{{ props.item.CSPID }}</a>
            </td>
            <td class="text-xs-left">{{ props.item.businessName }}</td>
            <td class="text-xs-right" :class="getBalanceClass(props.item.prepaidBalance)">
              {{ props.item.prepaidBalance | currency }}
            </td>
            <td class="text-xs-right">{{ props.item.smsRate | currency }}</td>
            <td class="text-xs-left">{{ props.item.recurlyID || '-' }}</td>
          </tr>
        </template>
        <template slot="footer">
          <td colspan="3" class="text-xs-right">Total:</td>
          <td class="text-xs-right">{{ totalBalance | currency }}</td>
          <td colspan="2"></td>
        </template>
        <v-alert slot="no-results" :value="true" color="error" icon="warning">
          Your search for "{{ search }}" found no results.
        </v-alert>
      </v-data-table>
    </v-card>
  </v-container>
</template>

<script>
import smsReportsService from '../service'

export default {
  name: 'wallet-balances',
  data() {
    return {
      headers: [
        { text: 'Store ID', value: 'storeID', sortable: true, width: '8%' },
        { text: 'CSPID', value: 'CSPID', sortable: true, width: '10%' },
        { text: 'Business Name', value: 'businessName', sortable: true },
        { text: 'Balance', value: 'prepaidBalance', sortable: true, width: '12%' },
        { text: 'SMS Rate', value: 'smsRate', sortable: true, width: '8%' },
        { text: 'Recurly ID', value: 'recurlyID', sortable: true, width: '18%' },
      ],
      search: null,
      items: [],
      loading: true,
      recurlyFilter: 'all',
      recurlyFilterOptions: [
        { text: 'All', value: 'all' },
        { text: 'Has Recurly', value: 'has' },
        { text: 'No Recurly', value: 'none' },
      ],
      pagination: {
        rowsPerPage: 25,
        sortBy: 'prepaidBalance',
        descending: true,
      },
    }
  },
  computed: {
    filteredItems() {
      if (this.recurlyFilter === 'has') {
        return this.items.filter((item) => item.recurlyID)
      }
      if (this.recurlyFilter === 'none') {
        return this.items.filter((item) => !item.recurlyID)
      }
      return this.items
    },
    totalBalance() {
      return this.filteredItems.reduce((sum, item) => sum + Number(item.prepaidBalance || 0), 0)
    },
  },
  created() {
    this.getList()
  },
  methods: {
    openLocation(item) {
      this.$router.push({ path: `/location/profile/${item.storeID}` })
    },
    getBalanceClass(balance) {
      if (balance < 0) return 'red--text'
      if (balance > 100) return 'green--text'
      return ''
    },
    reloadData() {
      this.getList()
    },
    getList() {
      this.loading = true
      return smsReportsService.getWalletBalances().then((response) => {
        this.items = response.data
        this.loading = false
        return response
      }).catch((error) => {
        this.loading = false
        console.error('Error fetching wallet balances:', error)
      })
    },
    downloadCSV() {
      const csvHeaders = ['Store ID', 'CSPID', 'Business Name', 'Balance', 'SMS Rate', 'Recurly ID']
      const csvRows = this.filteredItems.map((item) => [
        item.storeID,
        item.CSPID,
        `"${(item.businessName || '').replace(/"/g, '""')}"`,
        item.prepaidBalance,
        item.smsRate,
        item.recurlyID || '',
      ])

      const csvContent = [
        csvHeaders.join(','),
        ...csvRows.map((row) => row.join(',')),
      ].join('\n')

      const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' })
      const link = document.createElement('a')
      link.href = URL.createObjectURL(blob)
      link.download = 'WalletBalances.csv'
      link.click()
      URL.revokeObjectURL(link.href)
    },
  },
}
</script>
